import type { IconData } from '@stacksjs/iconify-core'

export const creditCardF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20 4H0V2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zm0 3v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7zM4 9a1 1 0 1 0 0 2h1a1 1 0 0 0 0-2zm5 0a1 1 0 1 0 0 2h5a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default creditCardF
